export const visit = (vm, at) => {
at({ "sv": { "conversationsVisitorUIAvailability": { "sameDay": "Vi kommer tillbaka idag kl. {{time}}", "nextDay": "Vi kommer tillbaka imorgon kl. {{time}}", "nextWeek": "Vi kommer tillbaka p\xE5 {{dayOfWeek}} kl. {{time}}" } } });
};